export const DEFAULT_AGENT_RETURN_PATH = "/agent/dashboard";

export const normalizeAgentReturnPath = (value) =>
  value === "/power-up" || value === "/agent/email" || value === DEFAULT_AGENT_RETURN_PATH
    ? value
    : DEFAULT_AGENT_RETURN_PATH;
